/**
 * TypeScript representation of the WarehouseHandlingTier enum
 * from the Java class com.amazon.warehouseHandlingTiers.WarehouseHandlingTier
 */
export enum WarehouseHandlingTier {
  Default = "Default",
  pa_expedited = "pa-expedited",
  expedited = "expedited",
  rapid = "rapid",
  rush = "rush",
  next = "next"
}

/**
 * Get all warehouse handling tier values as an array
 */
export const getAllTierValues = (): string[] => {
  return Object.values(WarehouseHandlingTier);
};
